import { useAppConfig } from '@jwp/ott-hooks-react/src/useAppConfig';
import { useAppInfo } from '@jwp/ott-hooks-react/src/useAppInfo';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MarkdownComponent from '../../components/MarkdownComponent/MarkdownComponent';
import HTMLRenderer from '../HTMLRender/HTMLRender';
import styles from './TermsOfUse.module.scss';
import { markdownPageEnglish, markdownPageSpanish } from './TermsOfUseContent';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

type Props = {
  panelClassName?: string;
  panelHeaderClassName?: string;
};

const TermsOfUse = ({ panelClassName, panelHeaderClassName }: Props): JSX.Element => {
  const { canShowTermsOfUse } = useAppConfig();
  const { termsOfUse } = useConfigStore.getState();
  const { i18n, t } = useTranslation('common');
  const markdownContent = () => {
    if (i18n.language === 'en') {
      return markdownPageEnglish;
    } else if (i18n.language === 'es') {
      return markdownPageSpanish;
    } else return 'Language not supported';
  };

  console.log('privacyPolicy', termsOfUse);

  if (!termsOfUse?.en && !termsOfUse?.es && canShowTermsOfUse) {
    return (
      <section className={panelClassName}>
        <div className={panelHeaderClassName}>
          <h2>{t('footer:terms_of_use')}</h2>
        </div>
        <MarkdownComponent className={styles.about} markdownStyle={styles.markdown} markdownString={markdownContent()} />
      </section>
    );
  }
  return (
    <>
      <section className={panelClassName}>
        <HTMLRenderer className={styles.legalDocsContainer} html={i18n.language == 'es' && termsOfUse ? termsOfUse.es : termsOfUse?.en} />
      </section>
    </>
  );
};

export default TermsOfUse;
